/**
 * Enum for order types.
 * @readonly
 * @enum {Number} OrderTypeEnum
 */

const OrderTypeEnum = {
  ALL         : 0,
  DELIVERY    : 1,
  COLLECTION  : 2,
  SELF_SERVICE: 3
}

export default OrderTypeEnum
